import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

/**
 * "Beta" tag for features that ship before a run on a real account
 * (Comment-to-DM and the comment keyword DM, card P9).
 */
export function BetaBadge({ className }: { readonly className?: string }) {
  return (
    <Badge
      variant="outline"
      className={cn('border-amber-500/40 bg-amber-500/10 px-1.5 py-0 text-[10px] uppercase tracking-wide text-amber-400', className)}
      title="Beta: new feature, still being tested on live accounts"
    >
      Beta
    </Badge>
  )
}
